module.exports = __webpack_public_path__ + "static/media/background-kakao-panda.466e63ff.png";